import { trackShareExternallyClicked } from '../events'
import { ShareContextData } from '../provider/ShareContext'
import getSocialMediaDialogUrl from './getSocialMediaDialogUrl'

const openSocialMediaDialog = ({
  channel,
  link,
  shareData,
}: {
  channel: string
  link: string
  shareData: ShareContextData
}) => {
  const encodedLink = encodeURIComponent(link)
  const socialMediaDialogUrl = getSocialMediaDialogUrl({
    channel,
    encodedLink,
  })

  trackShareExternallyClicked({ channel, link, shareData })

  window.open(socialMediaDialogUrl, 'Share Dialog', 'width=626,height=436')
}

export default openSocialMediaDialog
